import qs from 'query-string';
import {Product} from '../../../../shared/types';

const generateShareableLink = <T extends Product>(product: T, baseStoreUrl, accountId) => {
    const {namespace, pageSlug, urlSlug} = product || {};
    return qs.stringifyUrl({
        url: `${baseStoreUrl}/p/${pageSlug || urlSlug}`,
        query: {
            epic_creator_id: accountId,
            epic_game_id: namespace
        }
    });
};

export default generateShareableLink;
